import React from "react";
import TablaTargets from "js/pages/Admin/Programa/Campana/Targets/Tabla";

function Targets(props) {
  return <TablaTargets {...props} />;
}

export default Targets;
